import { PHONE, locationSchema } from "../structured-data-core";

export function getNationalStructuredData() {
  const url = "https://restorehair.com/locations/restore-northeast/";
  const description =
    "Restore your confidence with the top hair restoration team trusted by celebrities, athletes & everyday guys. Over 20,000 procedures.";
  return [
    locationSchema("Baltimore", "4000 East Pratt St, 8th Floor", "Baltimore", "MD", PHONE, url, description),
    locationSchema("Boston", "75 Arlington Street, Suite 500", "Boston", "MA", PHONE, url, description),
    locationSchema("Brooklyn Heights", "300 Cadman Plaza W", "Brooklyn Heights", "NY", PHONE, url, description),
    locationSchema("Manhasset", "1129 Northern Blvd", "Manhasset", "NY", PHONE, url, description),
    locationSchema("Manhattan", "240 W 37th St, 5th Floor", "Manhattan", "NY", PHONE, url, description),
    locationSchema("Melville", "555 Broadhollow Rd", "Melville", "NY", PHONE, url, description),
    locationSchema("Nassau County", "1979 Marcus Ave, Suite 210", "Lake Success", "NY", PHONE, url, description),
    locationSchema("Neptune", "3600 Route 66", "Neptune", "NJ", PHONE, url, description),
    locationSchema("Newark", "One Gateway Center", "Newark", "NJ", PHONE, url, description),
    locationSchema("Paramus", "140 E Ridgewood Avenue", "Paramus", "NJ", PHONE, url, description),
    locationSchema("Philadelphia", "325-41 Chestnut Street, Suite 800", "Philadelphia", "PA", PHONE, url, description),
    locationSchema("Pittsburgh", "322 North Shore Drive, Building 1B, Suite 200", "Pittsburgh", "PA", PHONE, url, description),
    locationSchema("Queens", "118-35 Queens Blvd, Forest Hills Tower", "Queens", "NY", PHONE, url, description),
    locationSchema("Washington DC", "1875 I Street, NW, 5th Floor", "Washington", "DC", PHONE, url, description),
    locationSchema("White Plains", "50 Main Street", "White Plains", "NY", PHONE, url, description),
  ];
}
